<statistics-has-sample-msg></statistics-has-sample-msg>
<page-header icon="fas fa-search" [header]="'Search Engines' | translate" [subHeader]="'View data for the selected period.' | translate" [panelClass]="(domain | isStatsSampleData) ? 'mt-1' : ''">
    <page-header-content>
        <statistics-date-picker (onApply)="updateDateRange()" [(date)]="date" dateRangeGroup="statistics" class="pull-right"></statistics-date-picker>
    </page-header-content>
</page-header>
<div class="card panel-monsido-card">
    <div class="card-body">
        <div class="row outer-b-xlarge" *ngIf="loading">
            <div class="col-48 text-center">
                <span class="fas fa-spinner fa-spin fa-3x fa-fw" aria-hidden="true"></span>
            </div>
        </div>
        <div class="row" *ngIf="!loading">
            <div class="col-48">
                <mon-chart-bar [data]="chartData"
                           [emptyDataMessage]="'No visits for this category in selected time frame' | translate"
                           [labels]="chartLabels"
                           [series]="chartSeries"
                           [options]="chartOptions"
                           [override]="chartOverride">
                </mon-chart-bar>
            </div>
            <div class="col-48">
                <table-container [collection]="pages"
                                 [progress]="promise"
                                 [noResultMessage]="'No visits for this category in selected time frame' | translate">
                    <table class="table table-hover table-fixed">
                        <thead>
                        <tr>
                            <th class="col-sm-8 col-md-8" translate>URL</th>
                            <th class="col-sm-8 col-md-8 text-center">
                                <span translate>Visits</span><br>
                                <span class="text-grey">({{summary.visits | monNumber:'0,0' }})</span>
                            </th>
                            <th class="col-sm-8 col-md-8 text-right"><span translate>Unique Visitors</span><br>
                                <span class="text-grey">({{summary.uniq_visitors | monNumber:'0,0' }})</span>
                            </th>
                            <th class="col-sm-8 col-md-8 text-right"><span translate>Bounce rate</span><br>
                                <span class="text-grey" *ngIf="summary.visits > 0">({{ (summary.bounce_rate / summary.visits) | monNumber:'0.[00]%'}})</span>
                                <span class="text-grey" *ngIf="summary.visits <= 0">( 0% )</span>
                            </th>
                            <th class="col-sm-8 col-md-8 text-right"><span translate>Actions per visit</span><br>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let page of pages">
                            <td class="text-ellipsis text-v-middle">
                                <statistics-url-title [title]="page.label" [url]="page.url"></statistics-url-title>
                            </td>
                            <td class="text-v-middle"><statistics-visits [visits]="page.visits" [totalVisits]="totalVisits"></statistics-visits></td>
                            <td class="text-v-middle text-right">{{page.uniq_visitors}}</td>
                            <td class="text-v-middle text-right">{{page.bounces / page.visits | monNumber:'0.[00]%'}}</td>
                            <td class="text-v-middle text-right">{{page.actions / page.visits | monNumber:'0.[00]'}}</td>
                        </tr>
                        </tbody>
                    </table>
                </table-container>
            </div>
        </div>
    </div>
</div>